(function () {
  'use strict';

  var GQL_FIELDS = '\n'
    + '      handle\n'
    + '      resort_name: field(key: "resort_name") { value }\n'
    + '      state:        field(key: "state")        { value }\n'
    + '      country:      field(key: "country")      { value }\n'
    + '      pass:         field(key: "pass_affiliation") { value }\n'
    + '      featured:     field(key: "featured")     { value }\n'
    + '      hero_image:   field(key: "hero_image")   {\n'
    + '        reference { ... on MediaImage { image { url altText } } }\n'
    + '      }\n'
    + '      resort_map:   field(key: "resort_map")   {\n'
    + '        reference {\n'
    + '          ... on MediaImage { image { url altText width height } }\n'
    + '          ... on GenericFile { url }\n'
    + '        }\n'
    + '      }\n';

  var CORNERS = ['tl', 'tr', 'bl', 'br', 'tc', 'bc', 'lc', 'rc'];
  var CORNER_LABEL = {
    tl: 'Top left', tr: 'Top right', bl: 'Bottom left', br: 'Bottom right',
    tc: 'Top center', bc: 'Bottom center', lc: 'Left center', rc: 'Right center'
  };

  // Placeholder — real per-resort white-space corners should come from
  // MapSynergy map metadata (captured as a metaobject field) once available.
  // Deterministic-by-handle so the same resort always shows the same corners.
  function availableCornersFor(handle) {
    if (!handle) return CORNERS;
    var sum = 0;
    for (var i = 0; i < handle.length; i++) sum += handle.charCodeAt(i);
    var patterns = [['br'], ['tr', 'br'], ['tl', 'br'], ['tl', 'tr', 'br', 'bc'], CORNERS];
    return patterns[sum % patterns.length];
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var n = parseFloat(cents) / 100;
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  // ---------------------------------------------------------------------------

  function PALogoBlanketPicker(root) {
    this.root       = root;
    this.shopDomain = root.dataset.shopDomain || '';
    this.token      = root.dataset.token      || '';
    this.pageSize   = parseInt(root.dataset.pageSize, 10) || 9;

    this.query        = '';
    this.activeFilter  = null;
    this.renderEnd    = this.pageSize;

    this.allResorts      = [];
    this.filteredResorts = [];

    this.selectedResort = null; // full resort node
    this.selectedCorner = null;

    // Step 1 DOM
    this.grid        = root.querySelector('.pa-lbp__grid');
    this.countEl      = root.querySelector('.pa-resort-picker__count');
    this.searchInput  = root.querySelector('.pa-resort-picker__search-input');
    this.showMoreBtn  = root.querySelector('.pa-lbp__show-more');
    this.emptyEl      = root.querySelector('.pa-resort-picker__empty');
    this.chipButtons  = root.querySelectorAll('.pa-resort-picker__chip[data-filter]');

    // Step 2 DOM
    this.mapStage       = root.querySelector('.pa-lbp__map-stage');
    this.mapImg         = root.querySelector('[data-lbp-map-img]');
    this.mapPlaceholder = root.querySelector('[data-lbp-map-placeholder]');
    this.cornerBtns     = root.querySelectorAll('.pa-lbp__corner-btn');
    this.cornerHelp     = root.querySelector('[data-lbp-corner-help]');
    this.resortNote     = root.querySelector('[data-lbp-resort-note]');

    // Cart-form wiring (lives in the main-product section further down the page)
    this.cartForm    = null;
    this.submitBtn   = null;
    this.submitLabel = null;
    this.mountainInput = null;
    this.cornerInput   = null;
    this.qtyInput       = null;
    this.summaryEl      = null;

    this._init();
  }

  PALogoBlanketPicker.prototype._init = function () {
    var self = this;

    this._bindCornerEvents();
    this._wireCartForm();

    if (!this.token) {
      this._status('Add your Storefront API token in Theme Customizer → Logo Blanket Picker settings.');
      return;
    }

    this._status('Loading resorts…');
    this._bindEvents();

    var promise = window.__PA_RESORTS
      ? Promise.resolve(window.__PA_RESORTS)
      : this._fetchAll();

    promise.then(function (resorts) {
      window.__PA_RESORTS = resorts;
      self.allResorts = resorts;
      self._applyFilters();
    }).catch(function (err) {
      self._status('Could not load resorts. Please refresh the page.');
      console.error('[PALogoBlanketPicker]', err);
    });
  };

  PALogoBlanketPicker.prototype._fetchAll = function () {
    var self     = this;
    var endpoint = 'https://' + this.shopDomain + '/api/2024-01/graphql.json';
    var headers  = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': this.token
    };

    var resorts = [];
    var cursor  = null;

    function fetchPage() {
      var after = cursor ? (', after: "' + cursor + '"') : '';
      var gql   = '{ metaobjects(type: "resort_profile", first: 250' + after + ') {\n'
        + '  pageInfo { endCursor hasNextPage }\n'
        + '  nodes {\n' + GQL_FIELDS + '  }\n'
        + '} }';

      return fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ query: gql })
      }).then(function (resp) {
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        return resp.json();
      }).then(function (json) {
        if (json.errors && json.errors.length) throw new Error(json.errors[0].message);
        var data = json.data.metaobjects;
        resorts  = resorts.concat(data.nodes);
        if (data.pageInfo.hasNextPage) {
          cursor = data.pageInfo.endCursor;
          return fetchPage();
        }
        return resorts;
      });
    }

    return fetchPage();
  };

  PALogoBlanketPicker.prototype._bindEvents = function () {
    var self = this;

    if (this.searchInput) {
      this.searchInput.addEventListener('input', function () {
        self.query     = this.value.toLowerCase().trim();
        self.renderEnd = self.pageSize;
        self._applyFilters();
      });
    }

    this.chipButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._setFilter(btn);
      });
    });

    if (this.showMoreBtn) {
      this.showMoreBtn.addEventListener('click', function () {
        self.renderEnd += self.pageSize;
        self._render();
      });
    }

    // Event delegation for resort card selection (grid is rebuilt on every render)
    if (this.grid) {
      this.grid.addEventListener('click', function (e) {
        var card = e.target.closest('[data-resort-handle]');
        if (!card) return;
        var handle = card.dataset.resortHandle;
        var resort = self.allResorts.find(function (r) { return r.handle === handle; });
        if (resort) self._selectResort(resort);
      });
    }
  };

  PALogoBlanketPicker.prototype._setFilter = function (btn) {
    var filterValue = btn.dataset.filter;

    if (filterValue === 'all') {
      this.activeFilter = null;
      this.chipButtons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    } else {
      var isActive = btn.getAttribute('aria-pressed') === 'true';
      this.chipButtons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      if (isActive) {
        this.activeFilter = null;
      } else {
        this.activeFilter = filterValue.toLowerCase();
        btn.setAttribute('aria-pressed', 'true');
      }
    }

    this.renderEnd = this.pageSize;
    this._applyFilters();
  };

  PALogoBlanketPicker.prototype._applyFilters = function () {
    var q = this.query;
    var f = this.activeFilter;

    this.filteredResorts = this.allResorts.filter(function (r) {
      var name    = ((r.resort_name && r.resort_name.value) || '').toLowerCase();
      var pass    = ((r.pass    && r.pass.value)    || '').toLowerCase();
      var state   = ((r.state   && r.state.value)   || '').toLowerCase();
      var country = ((r.country && r.country.value) || '').toLowerCase();

      if (q && name.indexOf(q) === -1) return false;
      if (f && pass !== f && state !== f && country !== f) return false;
      return true;
    });

    this._render();
  };

  PALogoBlanketPicker.prototype._render = function () {
    var visible = this.filteredResorts.slice(0, this.renderEnd);
    var hasMore = this.filteredResorts.length > this.renderEnd;

    if (this.emptyEl) this.emptyEl.hidden = visible.length > 0;

    this.grid.innerHTML = visible.length
      ? visible.map(this._buildCard.bind(this)).join('')
      : '';

    if (this.showMoreBtn) this.showMoreBtn.hidden = !hasMore;
    this._updateCount();
  };

  PALogoBlanketPicker.prototype._updateCount = function () {
    if (!this.countEl) return;
    var total = this.filteredResorts.length;
    var shown = Math.min(this.renderEnd, total);
    if (total === 0) {
      this.countEl.textContent = 'No resorts found';
    } else if (shown >= total) {
      this.countEl.textContent = 'Showing all ' + total + ' resorts';
    } else {
      this.countEl.textContent = 'Showing ' + shown + ' of ' + total + ' resorts';
    }
  };

  PALogoBlanketPicker.prototype._buildCard = function (r) {
    var name     = (r.resort_name && r.resort_name.value) || '';
    var state    = (r.state   && r.state.value)   || '';
    var country  = (r.country && r.country.value) || '';
    var pass     = (r.pass    && r.pass.value)    || '';
    var featured = r.featured && r.featured.value === 'true';
    var handle   = r.handle || '';
    var selected = this.selectedResort && this.selectedResort.handle === handle;

    var heroImg = r.hero_image && r.hero_image.reference && r.hero_image.reference.image;
    var mapRef  = r.resort_map && r.resort_map.reference;
    var mapImg  = mapRef && (mapRef.image || (mapRef.url ? { url: mapRef.url, altText: null } : null));
    var img     = heroImg || mapImg;

    var mediaHTML;
    if (img && img.url) {
      var baseUrl = img.url.split('?')[0];
      var altText = esc(img.altText || name);
      var srcset  = baseUrl + '?width=300 300w, ' + baseUrl + '?width=500 500w, ' + baseUrl + '?width=800 800w';
      mediaHTML = '<img class="pa-photo-slot__img"'
        + ' src="' + baseUrl + '?width=400"'
        + ' srcset="' + srcset + '"'
        + ' sizes="(min-width:1200px) 300px,(min-width:990px) 25vw,(min-width:750px) 33vw,50vw"'
        + ' alt="' + altText + '"'
        + ' loading="lazy" width="400" height="400">';
    } else {
      mediaHTML = '<div class="pa-photo-slot__placeholder" aria-hidden="true"></div>';
    }

    var badgesHTML = '';
    if (featured) badgesHTML += '<span class="pa-resort-card__featured-badge">&#9733; Featured</span>';
    if (pass) {
      var slug = pass.toLowerCase().replace(/\s+/g, '-');
      badgesHTML += '<span class="pa-pass-badge pa-pass-badge--on-image">'
        + '<span class="pa-pass-badge__dot pa-pass-badge__dot--' + esc(slug) + '" aria-hidden="true"></span>'
        + esc(pass) + '</span>';
    }

    var location = '';
    if (state && country) location = esc(state) + ', ' + esc(country);
    else if (state) location = esc(state);
    else if (country) location = esc(country);

    return '<li class="pa-resort-picker__item">'
      + '<button type="button" class="pa-resort-card pa-lbp__resort-card" data-resort-handle="' + esc(handle) + '"'
      + ' aria-pressed="' + (selected ? 'true' : 'false') + '"'
      + ' aria-label="Select ' + esc(name) + '">'
      + '<div class="pa-resort-card__media">' + mediaHTML + '</div>'
      + '<div class="pa-resort-card__overlay" aria-hidden="true"></div>'
      + '<div class="pa-resort-card__badges">' + badgesHTML + '</div>'
      + '<span class="pa-lbp__resort-check" aria-hidden="true">' + '&#10003;' + '</span>'
      + '<div class="pa-resort-card__body">'
      + '<p class="pa-resort-card__name">' + esc(name) + '</p>'
      + (location ? '<p class="pa-resort-card__location">' + location + '</p>' : '')
      + '</div>'
      + '</button>'
      + '</li>';
  };

  PALogoBlanketPicker.prototype._status = function (msg) {
    if (this.grid) {
      this.grid.innerHTML = '<li class="pa-resort-picker__status">' + esc(msg) + '</li>';
    }
  };

  // ---------------------------------------------------------------------------
  // Step 2 — corner placement

  PALogoBlanketPicker.prototype._selectResort = function (resort) {
    this.selectedResort = resort;
    this.selectedCorner = null;

    // Update card selection state without a full re-render
    this.grid.querySelectorAll('[data-resort-handle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.resortHandle === resort.handle ? 'true' : 'false');
    });

    var name = (resort.resort_name && resort.resort_name.value) || '';

    if (this.resortNote) {
      this.resortNote.innerHTML = 'Showing placement options for <strong>' + esc(name) + '</strong>.';
      this.resortNote.hidden = false;
    }

    // Map preview
    var mapRef = resort.resort_map && resort.resort_map.reference;
    var mapImg = mapRef && (mapRef.image || (mapRef.url ? { url: mapRef.url } : null));
    if (mapImg && mapImg.url && this.mapImg) {
      this.mapImg.src = mapImg.url.split('?')[0] + '?width=1200';
      this.mapImg.alt = name + ' trail map';
      this.mapImg.hidden = false;
      if (this.mapPlaceholder) this.mapPlaceholder.hidden = true;
    } else if (this.mapImg) {
      this.mapImg.hidden = true;
      if (this.mapPlaceholder) this.mapPlaceholder.hidden = false;
    }

    var available = availableCornersFor(resort.handle);
    this.cornerBtns.forEach(function (btn) {
      var corner    = btn.dataset.corner;
      var isEnabled = available.indexOf(corner) !== -1;
      btn.disabled  = !isEnabled;
      btn.setAttribute('aria-pressed', 'false');
      btn.title = isEnabled
        ? CORNER_LABEL[corner]
        : CORNER_LABEL[corner] + ' — no open space on this map';
      var check = btn.querySelector('.pa-lbp__corner-check');
      if (check) check.hidden = true;
    });

    if (this.cornerHelp) {
      this.cornerHelp.textContent = available.length < CORNERS.length
        ? 'Greyed-out corners have printed map detail on ' + name + ' — pick an open one.'
        : 'All corners are open on this map.';
    }

    this._syncCart();
  };

  PALogoBlanketPicker.prototype._bindCornerEvents = function () {
    var self = this;
    this.cornerBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        self.selectedCorner = btn.dataset.corner;
        self.cornerBtns.forEach(function (b) {
          var isSelected = b === btn;
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          var check = b.querySelector('.pa-lbp__corner-check');
          if (check) check.hidden = !isSelected;
        });
        if (self.cornerHelp) {
          self.cornerHelp.textContent = 'Logo placement: ' + CORNER_LABEL[self.selectedCorner] + '.';
        }
        self._syncCart();
      });
    });
  };

  // ---------------------------------------------------------------------------
  // Wire selections into the main-product add-to-cart form further down the page

  PALogoBlanketPicker.prototype._wireCartForm = function () {
    this.cartForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!this.cartForm) return;

    this.submitBtn = this.cartForm.querySelector('.product-form__submit');
    if (this.submitBtn && !this.submitLabel) {
      this.submitLabel = (this.submitBtn.querySelector('span') || this.submitBtn).textContent.trim();
    }

    this.mountainInput = this.cartForm.querySelector('input[name="properties[Mountain]"]');
    if (!this.mountainInput) {
      this.mountainInput = document.createElement('input');
      this.mountainInput.type = 'hidden';
      this.mountainInput.name = 'properties[Mountain]';
      this.cartForm.appendChild(this.mountainInput);
    }

    this.cornerInput = this.cartForm.querySelector('input[name="properties[Logo Corner]"]');
    if (!this.cornerInput) {
      this.cornerInput = document.createElement('input');
      this.cornerInput.type = 'hidden';
      this.cornerInput.name = 'properties[Logo Corner]';
      this.cartForm.appendChild(this.cornerInput);
    }

    this.summaryEl = document.getElementById('pa-lbp-summary');
    this.qtyInput  = document.querySelector('.product-form__quantity .quantity__input');
    if (this.qtyInput) {
      var self = this;
      this.qtyInput.addEventListener('change', function () { self._syncCart(); });
      this.qtyInput.addEventListener('input', function () { self._syncCart(); });
    }

    this._syncCart();
  };

  PALogoBlanketPicker.prototype._syncCart = function () {
    if (!this.cartForm) this._wireCartForm();
    if (!this.cartForm) return;

    var name   = this.selectedResort ? ((this.selectedResort.resort_name && this.selectedResort.resort_name.value) || '') : '';
    var corner = this.selectedCorner ? CORNER_LABEL[this.selectedCorner] : '';
    var ready  = !!this.selectedResort && !!this.selectedCorner;

    if (this.mountainInput) this.mountainInput.value = name;
    if (this.cornerInput)   this.cornerInput.value   = corner;

    if (this.submitBtn) {
      this.submitBtn.disabled = !ready;
      var labelEl = this.submitBtn.querySelector('span') || this.submitBtn;
      labelEl.textContent = ready ? this.submitLabel : 'Choose Mountain & Corner First';
    }

    if (this.summaryEl) {
      var mountainEl = this.summaryEl.querySelector('[data-lbp-summary-mountain]');
      var cornerEl   = this.summaryEl.querySelector('[data-lbp-summary-corner]');
      var qtyEl      = this.summaryEl.querySelector('[data-lbp-summary-qty]');
      var totalEl    = this.summaryEl.querySelector('[data-lbp-summary-total]');
      var qty        = this.qtyInput ? (parseInt(this.qtyInput.value, 10) || 1) : 1;
      var priceCents = parseInt(this.summaryEl.dataset.priceCents, 10) || 0;

      if (mountainEl) mountainEl.textContent = name || 'Not chosen yet';
      if (cornerEl)   cornerEl.textContent   = corner || 'Not chosen yet';
      if (qtyEl)      qtyEl.textContent      = qty;
      if (totalEl)    totalEl.textContent    = formatMoney(priceCents * qty);
    }
  };

  // ---------------------------------------------------------------------------

  function boot() {
    document.querySelectorAll('[data-logo-picker]').forEach(function (el) {
      new PALogoBlanketPicker(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
